module.exports = __webpack_public_path__ + "img/shot_img112503.8fb64825.gif";